import React, { useState } from 'react'
import { HelpCircle as HelpCircleIcon, Plus as PlusIcon } from 'react-feather'
import { Box, Button, Tab, Tabs } from '@material-ui/core'

import {
  Container,
  ContentHeader,
  DriveTour,
  FilterButton,
  Page,
  Permitted,
} from 'components'
import { MyPhishing, PhishingFilters, PhishingTutorial } from './components'

import useFilter from 'hooks/useFilter'
import constants from 'constants/index'
import * as service from 'service'
import { routes } from 'Routes'
import {
  PHISHING_TUTORIAL_STEP_1,
  PHISHING_TUTORIAL_STEP_2,
  phishingTutorialSteps,
} from './driverSteps'

const PhishingMain = () => {
  const [openTour, setOpenTour] = useState(false)
  const [currentTab, setCurrentTab] = useState(constants.phishing.ALL_TAB_VALUE)

  const filter = useFilter()

  const handleOpenTour = () => setOpenTour(true)
  const handleTabChange = (_, value) => setCurrentTab(value)

  return (
    <Page title="Phishing">
      <Container maxWidth={false}>
        <ContentHeader title="Phishing">
          <Button
            id={PHISHING_TUTORIAL_STEP_1}
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={handleOpenTour}
            fullWidth
          >
            Tutorial
          </Button>
          <Permitted tag={constants.permissions.PHISHING.MANAGE}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlusIcon size={20} />}
              onClick={() => service.history.push(routes.phishing.new)}
              fullWidth
            >
              NOVA CAMPANHA
            </Button>
          </Permitted>
          <FilterButton setDrawerOpen={filter.setDrawerOpen} fullWidth />
        </ContentHeader>
        <Box mb={3}>
          <PhishingTutorial />
        </Box>
        <Tabs
          id={PHISHING_TUTORIAL_STEP_2}
          value={currentTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleTabChange}
        >
          {constants.phishing.TABS.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
        <Box mt={2}>
          <MyPhishing filter={filter} currentTab={currentTab} />
        </Box>
      </Container>
      <PhishingFilters filter={filter} />
      <DriveTour
        stepsMatrix={phishingTutorialSteps}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default PhishingMain
